export default "__VITE_ASSET__EHgCgpc7__"